export default __webpack_public_path__ + "static/media/school-white.71413f88.svg";